import { CSSProperties, FC } from 'react';
import { ITreeIcon } from './interfaces';
import cn from 'classnames';

export const TreeIcon: FC<ITreeIcon> = ({
  children,
  size,
  className,
  ...props
}) => {
  return (
    <div
      style={{ '--width': `${size || 24}px` } as CSSProperties}
      className={cn('h-6 flex items-center pr-1 w-[--width]', className)}
      {...props}
    >
      {children}
    </div>
  );
};
